import React, { useState } from "react";
import { BrowserRouter as Router, Link, Navigate, Route, Routes } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
import { useAuth0 } from "@auth0/auth0-react";
import AuthProvider, { RequireAuth } from "./AuthProvider";
import { getConfig } from "./config";
import AuthCallback from "./components/AuthCallback";
import garconLogo from "./assets/garcon_icon_notext.png";
import { CartProvider } from "./context/CartContext";
import { DataProvider } from "./context/DataProvider";
import OrderPage from "./pages/OrderPage";
import OrderSummaryPage from "./pages/OrderSummaryPage";
import QRScanPage from "./pages/QRScanPage";

const GuestShell = ({ children }) => {
  const { guestAuthEnabled } = getConfig();
  const [expanded, setExpanded] = useState(false);
  const { isAuthenticated } = useAuth0();

  const handleNavLinkClick = () => {
    setExpanded(false);
  };

  return (
    <div className="guest-shell">
      <Navbar
        bg="white"
        expand="lg"
        className="mb-3 px-3 guest-navbar"
        expanded={expanded}
        onToggle={setExpanded}
      >
        <Navbar.Brand as={Link} to="/order" className="d-flex align-items-center guest-brand" onClick={handleNavLinkClick}>
          <img
            src={garconLogo}
            alt="Garcon"
            className="d-inline-block align-top"
          />
          <div className="guest-brand-copy">
            <span className="guest-brand-title">Garcon</span>
            <span className="guest-brand-subtitle">QR Sipariş</span>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/order" onClick={handleNavLinkClick} className="guest-nav-link">
              Sipariş
            </Nav.Link>
            {(!guestAuthEnabled || isAuthenticated) && (
              <Nav.Link as={Link} to="/order-summary" onClick={handleNavLinkClick} className="guest-nav-link">
                Sipariş Özeti
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <main className="guest-shell-main">{children}</main>
    </div>
  );
};

const App = () => {
  const { guestAuthEnabled } = getConfig();

  const orderSummaryElement = (
    <GuestShell>
      <OrderSummaryPage />
    </GuestShell>
  );

  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <DataProvider>
            <Routes>
              <Route path="/qr-scan" element={<QRScanPage />} />
              <Route path="/q/:slug" element={<QRScanPage />} />
              <Route
                path="/order"
                element={
                  <GuestShell>
                    <OrderPage />
                  </GuestShell>
                }
              />
              <Route
                path="/order-summary"
                element={
                  guestAuthEnabled ? (
                    <RequireAuth>{orderSummaryElement}</RequireAuth>
                  ) : (
                    orderSummaryElement
                  )
                }
              />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="*" element={<Navigate to="/order" replace />} />
            </Routes>
          </DataProvider>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
